import { render, staticRenderFns } from "./FuelSupplierDetail.vue?vue&type=template&id=554338ec&scoped=true&"
import script from "./FuelSupplierDetail.vue?vue&type=script&lang=js&"
export * from "./FuelSupplierDetail.vue?vue&type=script&lang=js&"
import style0 from "./FuelSupplierDetail.vue?vue&type=style&index=0&id=554338ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554338ec",
  null
  
)

export default component.exports